import React, { useEffect, useRef, useState } from "react";
import { subscribeToasts, resolveConfirm } from "../map/toast";
import "./OCKCloud.css";

export default function OCKToasts() {
  const [items, setItems] = useState([]);
  const timersRef = useRef([]);
  const mountedRef = useRef(false);

  const hasConfirmToast = items.some((t) => t.type === "confirm");

  const safeSetItems = (updater) => {
    if (mountedRef.current) {
      setItems(updater);
    }
  };

  useEffect(() => {
    mountedRef.current = true;

    const unsubscribe = subscribeToasts((t) => {
      safeSetItems((prev) => {
        const existingIndex = prev.findIndex((item) => item.id === t.id);

        if (existingIndex >= 0) {
          const next = [...prev];
          next[existingIndex] = {
            ...next[existingIndex],
            message: t.message,
            type: t.type || next[existingIndex].type,
          };
          return next;
        }

        return [...prev, t];
      });

      if (t.type && !["confirm", "loading"].includes(t.type)) {
        const timerId = window.setTimeout(() => {
          safeSetItems((prev) => prev.filter((x) => x.id !== t.id));
        }, (t.duration ?? 4000) + 300);

        timersRef.current.push(timerId);
      }
    });

    return () => {
      mountedRef.current = false;

      timersRef.current.forEach((timerId) => {
        window.clearTimeout(timerId);
      });
      timersRef.current = [];

      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, []);

  const handleConfirm = (id) => {
    resolveConfirm(id, true);
    safeSetItems((prev) => prev.filter((x) => x.id !== id));
  };

  const handleCancel = (id) => {
    resolveConfirm(id, false);
    safeSetItems((prev) => prev.filter((x) => x.id !== id));
  };

  const handleDismiss = (id) => {
    safeSetItems((prev) => prev.filter((x) => x.id !== id));
  };

  return (
    <>
      {hasConfirmToast ? (
        <div
          className="ock-toast-overlay active"
          onClick={() => {
            const confirmToast = items.find((t) => t.type === "confirm");
            if (confirmToast) handleCancel(confirmToast.resolveId || confirmToast.id);
          }}
          aria-hidden="true"
        />
      ) : null}

      <div className="ock-toast-stack" aria-live="polite" aria-relevant="additions">
        {items.map((t) => (
          <div
            key={t.id}
            className={`ock-toast-item ${t.type}`}
            style={{ "--toast-life": `${t.duration ?? 4000}ms` }}
            role={t.type === "confirm" ? "dialog" : "status"}
          >
            {t.type === "loading" ? (
              <>
                <div className="ock-loading-spinner" aria-hidden="true" />
                <span className="ock-loading-text">{t.message}</span>
                <button
                  className="ock-loading-close"
                  onClick={() => handleDismiss(t.id)}
                  title="Закрыть"
                  type="button"
                >
                  ×
                </button>
              </>
            ) : null}

            {!["loading", "confirm"].includes(t.type) ? (
              <span>{t.message}</span>
            ) : null}

            {t.type === "confirm" ? (
              <>
                <span className="ock-confirm-message">{t.message}</span>
                <div className="ock-confirm-buttons">
                  <button
                    className="ock-confirm-btn ock-confirm-btn--no"
                    onClick={() => handleCancel(t.resolveId || t.id)}
                    type="button"
                  >
                    Отмена
                  </button>
                  <button
                    className="ock-confirm-btn ock-confirm-btn--yes"
                    onClick={() => handleConfirm(t.resolveId || t.id)}
                    type="button"
                    autoFocus
                  >
                    Да
                  </button>
                </div>
              </>
            ) : null}
          </div>
        ))}
      </div>
    </>
  );
}